import * as z from 'zod';

import type { CreateSchemaTypes } from '../createZodSchema';

export function radioValidator(field: CreateSchemaTypes) {
  const validator = field.required
    ? z.string().trim().min(1, 'Dit veld is verplicht')
    : z.string().trim();

  if (field.required) {
    return validator;
  }

  return z.preprocess((value) => (value === '' ? undefined : value), validator.optional().nullable());
}
